
export default {
    ajaxRequestsCount: 0,
    vars: {},
    lastUpdateTime : 0,
    months: [
        {id: 1, title:'January'},
        {id: 2, title:'February'},
        {id: 3, title: 'March'},
        {id: 4, title:'April'},
        {id: 5, title:'May'},
        {id: 6, title: 'June'},
        {id: 7, title: 'July'},
        {id: 8, title: 'August'},
        {id: 9, title: 'September'},
        {id: 10, title:'October'},
        {id: 11, title:'November'},
        {id: 12, title: 'December'}
        ],
    days: [
        {id: 0, title:'All'},
        {id: 1, title:'1'},
        {id: 2, title:'2'},
        {id: 3, title: '3'},
        {id: 4, title:'4'},
        {id: 5, title:'5'},
        {id: 6, title: '6'},
        {id: 7, title: '7'},
        {id: 8, title: '8'},
        {id: 9, title: '9'},
        {id: 10, title:'10'},
        {id: 11, title:'11'},
        {id: 12, title: '12'},
        {id: 13, title:'13'},
        {id: 14, title:'14'},
        {id: 15, title: '15'},
        {id: 16, title:'16'},
        {id: 17, title:'17'},
        {id: 18, title: '18'},
        {id: 19, title: '19'},
        {id: 20, title: '20'},
        {id: 21, title: '21'},
        {id: 22, title:'22'},
        {id: 23, title:'23'},
        {id: 24, title: '24'},
        {id: 25, title: '25'},
        {id: 26, title: '26'},
        {id: 27, title: '27'},
        {id: 28, title: '28'},
        {id: 29, title: '29'},
        {id: 30, title: '30'},
        {id: 31, title: '31'},
        ],

}
